import React from "react";
import { useFormContext } from "react-hook-form";
import { useIntl } from "react-intl";
import ReactHookDsmInput from "../../../../../modules/Helpers/ReactHookDsmInput2";
import RowTextFieldWithMetrics from "../../../../../modules/Farms/Intervention/RowControlledTextFieldWithMetrics2";
import { Spacer } from "../../../helpers/Spacer";
import {
  BeefOutputCalves,
  BeefOutputGrowing,
} from "../../../../models/Baseline/BeefBaseline";

type OutputData = BeefOutputGrowing | BeefOutputCalves;
type OutputDataKeys = keyof BeefOutputGrowing | keyof BeefOutputCalves;

interface BeefOutputInputFieldProps {
  fieldItemPrefix: string;
  keyName: OutputDataKeys;
  originalKey: string;
  labelId: string;
  tooltipId?: string;
  adornmentId?: string;
  adornmentValues?: Record<string, any>;
  outputData: OutputData;
  editEnabled: boolean;
}

const BeefOutputInputField: React.FC<BeefOutputInputFieldProps> = ({
  fieldItemPrefix,
  keyName,
  originalKey,
  labelId,
  tooltipId,
  adornmentId,
  adornmentValues,
  outputData,
  editEnabled,
}) => {
  const fc = useFormContext<BeefOutputGrowing>();
  const intl = useIntl();

  const value = fc.getValues(`${fieldItemPrefix}.${keyName}`);
  const baselineValue = outputData?.[keyName as keyof OutputData];

  const label = intl.formatMessage({ id: labelId });
  const tooltip = tooltipId ? intl.formatMessage({ id: tooltipId }) : "";
  const adornment = adornmentId
    ? intl.formatMessage({ id: adornmentId }, adornmentValues)
    : "";

  if (!editEnabled) {
    if (value) {
      return (
        <>
          <RowTextFieldWithMetrics
            name={`${fieldItemPrefix}.${keyName}`}
            label={label}
            tooltip={tooltip}
            type="number"
            metricUnit={adornment}
            baseline={baselineValue}
            disabled
            displayTypeSelect={false}
          />
          <Spacer />
        </>
      );
    }
    return (
      <ReactHookDsmInput
        name={`${fieldItemPrefix}.${originalKey}`}
        label={label}
        tooltip={tooltip}
        adornment={adornment}
        type="number"
        defaultValue={baselineValue}
        disabled
      />
    );
  }

  return (
    <>
      <RowTextFieldWithMetrics
        name={`${fieldItemPrefix}.${keyName}`}
        label={label}
        tooltip={tooltip}
        type="number"
        metricUnit={adornment}
        baseline={baselineValue}
        disabled={!editEnabled}
        displayTypeSelect={editEnabled}
      />
      <Spacer />
    </>
  );
};

BeefOutputInputField.defaultProps = {
  adornmentId: "",
  adornmentValues: [],
  tooltipId: "",
};

export default BeefOutputInputField;
